module.exports = __webpack_public_path__ + "img/制御工学8_3.5293c984.png";